import { ApiPaths } from "../../../api/ApiPaths";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetLoginLogListSuccessResponseType = {
    loginLogList: [{
        userId: string,
        userName: string,
        email: string,
        role: string,
        time: string,
        houseIdList: string[]
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getLoginLogList(): Promise<GetLoginLogListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.loginLogList,
        {},
        () => {},
        () => {});
}
